"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandedTimeZoneDecoder = exports.brandTimeZone = exports.brandTimeZoneUnsafe = exports.validateTimeZone = void 0;
const luxon_1 = require("luxon");
const D = __importStar(require("schemawax"));
class InvalidBrandZoneError extends Error {
    constructor(message) {
        super(message);
        this.name = "InvalidBrandZoneError";
    }
}
const validateTimeZone = (rawTimeZone) => {
    try {
        const validationResult = luxon_1.DateTime.local().setZone(rawTimeZone);
        return validationResult.isValid;
    }
    catch (error) {
        return false;
    }
};
exports.validateTimeZone = validateTimeZone;
const brandTimeZoneUnsafe = (rawTimeZone) => rawTimeZone;
exports.brandTimeZoneUnsafe = brandTimeZoneUnsafe;
const brandTimeZone = (rawTimeZone) => {
    if ((0, exports.validateTimeZone)(rawTimeZone)) {
        return rawTimeZone;
    }
    throw new InvalidBrandZoneError(`This is not a time zone: '${rawTimeZone}'`);
};
exports.brandTimeZone = brandTimeZone;
exports.brandedTimeZoneDecoder = D.string.andThen((data) => {
    try {
        return (0, exports.brandTimeZone)(data);
    }
    catch (error) {
        if (error instanceof InvalidBrandZoneError) {
            throw new D.DecoderError(error.message);
        }
        throw error;
    }
});
//# sourceMappingURL=time-zone.js.map